module.exports = __webpack_public_path__ + "static/media/Tarjeta-Zona-Redcompensas.296fcc2c.png";